import amenityTypesJson from '../../shared/amenities/amenityTypes.json';
import { getAmenityIcon } from './amenityIconMap';

let cachedAmenityTypes = null;

function buildAmenityTypesMap() {
  const amenityTypes = new Map();

  [...amenityTypesJson]
    .sort((left, right) => left.priority - right.priority)
    .forEach((amenityDefinition) => {
      amenityTypes.set(amenityDefinition.name, {
        priority: amenityDefinition.priority,
        icon: getAmenityIcon(amenityDefinition.iconName),
        label: amenityDefinition.label,
        antiLabel: amenityDefinition.antiLabel,
        displayAnti: amenityDefinition.displayAntiLabel,
      });
    });

  return amenityTypes;
}

export const getAmenityTypes = () => {
  if (!cachedAmenityTypes) {
    cachedAmenityTypes = buildAmenityTypesMap();
  }
  return cachedAmenityTypes;
};

export const getAmenityTypeKeys = () => Array.from(getAmenityTypes().keys());

export const resetAmenityTypesCacheForTests = () => {
  cachedAmenityTypes = null;
};
